import { Country } from '@kinomap-dev/ng-ui-lib/core';
import { ContentCountryItem } from '../types/country-viewer-repartition.type';
import { getCountryCode } from './get-country-code';

export function getKinomapFlagUrl(
  country: ContentCountryItem,
  countriesList: Country[] | undefined,
): string | undefined {
  if (!countriesList) return;
  const countryCode: string | undefined = getCountryCode(country, countriesList);
  return countryCode ? `assets/storybook-assets/flags/${countryCode}.svg` : undefined;
}
